import { createI18n } from "vue-i18n";

export const i18n = createI18n({
  locale: getLocale(),
  fallbackLocale: "de",
  messages: getTranslations(),
  silentTranslationWarn: true,
  legacy: false,
  missingWarn: false,
  fallbackWarn: false,
});

export function getLocale() {
  return document.documentElement.lang;
}

function getTranslations() {
  const json = document.querySelector("#vue-translations").innerText;
  return {
    [getLocale()]: JSON.parse(json),
  };
}
